import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: null,
    isReady: false,
    providers: null
};

const gamificationSlice = createSlice({
    name: 'gamification',
    initialState,
    reducers: {
        setGamificationData: (state, action) => {
            return { ...state, ...action.payload };
        },
        updateScore: (state, action) => {
            state.score = action.payload;
        },
        updateLevel: (state, action) => {
            state.level = action.payload;
        },
        initProviders: (state, action) => {
            state.providers = action.payload
        },
        updateProviderScored: (state, action) => {
            const { myProviderId, myScore } = action.payload;
            state.providers = {
                ...state.providers,
                [myProviderId]: { ...state.providers[myProviderId], score: state.providers[myProviderId]?.score + Number(myScore) }
            };
        }
    },
});

export const gamificationActions = gamificationSlice.actions;
export default gamificationSlice
